import { useTranslation } from 'react-i18next';

export default function Products() {
  const { t } = useTranslation('common');

  const categories = [
    {
      title: t('products_cat1_title'),
      description: t('products_cat1_desc'),
      image: 'https://public.readdy.ai/ai/img_res/25a307d288d24a253a34ed7a81d73102.jpg',
      color: 'from-amber-500 to-orange-600',
      icon: 'ri-restaurant-line'
    },
    {
      title: t('products_cat2_title'),
      description: t('products_cat2_desc'),
      image: 'https://readdy.ai/api/search-image?query=Colorful%20assortment%20of%20fresh%20Mexican%20chili%20peppers%20including%20jalapeno%20serrano%20habanero%20arranged%20on%20white%20background%2C%20vibrant%20red%20green%20orange%20colors%2C%20professional%20food%20photography%2C%20clean%20simple%20composition&width=400&height=300&seq=prod2&orientation=landscape',
      color: 'from-red-500 to-rose-600',
      icon: 'ri-fire-line'
    },
    {
      title: t('products_cat3_title'),
      description: t('products_cat3_desc'),
      image: 'https://readdy.ai/api/search-image?query=Various%20types%20of%20dried%20beans%20in%20wooden%20bowls%20including%20black%20beans%20pinto%20beans%20on%20white%20background%2C%20rustic%20presentation%2C%20professional%20food%20photography%2C%20natural%20earthy%20tones%2C%20simple%20clean%20composition&width=400&height=300&seq=prod3&orientation=landscape',
      color: 'from-emerald-500 to-teal-600',
      icon: 'ri-seedling-line'
    },
    {
      title: t('products_cat4_title'),
      description: t('products_cat4_desc'),
      image: 'https://readdy.ai/api/search-image?query=Mexican%20spices%20and%20seasonings%20in%20small%20bowls%20including%20cumin%20oregano%20cinnamon%20on%20white%20background%2C%20colorful%20aromatic%20spices%2C%20professional%20food%20photography%2C%20warm%20natural%20lighting%2C%20clean%20simple%20arrangement&width=400&height=300&seq=prod4&orientation=landscape',
      color: 'from-orange-500 to-amber-600',
      icon: 'ri-flask-line'
    },
    {
      title: t('products_cat5_title'),
      description: t('products_cat5_desc'),
      image: 'https://readdy.ai/api/search-image?query=Colorful%20assortment%20of%20traditional%20Mexican%20candies%20and%20sweets%20including%20mazapan%20tamarindo%20candy%20arranged%20on%20white%20background%2C%20vibrant%20colors%2C%20professional%20food%20photography%2C%20festive%20presentation%2C%20clean%20simple%20composition&width=400&height=300&seq=prod5&orientation=landscape',
      color: 'from-pink-500 to-fuchsia-600',
      icon: 'ri-cake-3-line'
    },
    {
      title: t('products_cat6_title'),
      description: t('products_cat6_desc'),
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Mexican%20pan%20de%20muerto%20bread%20with%20sugar%20coating%20on%20white%20background%2C%20festive%20seasonal%20bread%2C%20professional%20food%20photography%2C%20warm%20golden%20tones%2C%20clean%20simple%20presentation%2C%20Day%20of%20the%20Dead%20celebration%20bread&width=400&height=300&seq=prod6&orientation=landscape',
      color: 'from-yellow-500 to-orange-600',
      icon: 'ri-calendar-event-line'
    }
  ];

  return (
    <section id="productos" className="py-20 bg-gradient-to-br from-orange-50 via-red-50 to-yellow-50 relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-red-300/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-orange-300/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 w-80 h-80 bg-yellow-300/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-16 animate-fade-in">
          <div className="inline-block bg-gradient-to-r from-red-600 to-orange-600 text-white px-6 py-3 rounded-full text-sm font-bold mb-6 shadow-lg animate-bounce">
            <i className="ri-shopping-basket-line mr-2"></i>
            {t('products_badge')}
          </div>
          <h2 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6 bg-gradient-to-r from-red-600 via-orange-600 to-yellow-600 bg-clip-text text-transparent">
            {t('products_title')}
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto font-medium">
            {t('products_subtitle')}
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category, index) => (
            <div 
              key={index}
              className="group relative bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-3 cursor-pointer animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Gradient Border Effect */}
              <div className={`absolute inset-0 bg-gradient-to-br ${category.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl`}></div>
              
              <div className="relative bg-white rounded-3xl overflow-hidden">
                {/* Icon Badge */}
                <div className={`absolute top-4 right-4 z-20 w-12 h-12 flex items-center justify-center bg-gradient-to-br ${category.color} rounded-full shadow-lg transform group-hover:scale-110 group-hover:rotate-12 transition-all duration-500`}>
                  <i className={`${category.icon} text-2xl text-white`}></i>
                </div>

                {/* Product Image */}
                <div className="relative w-full h-64 overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200">
                  <img 
                    src={category.image}
                    alt={category.title}
                    className="w-full h-full object-cover group-hover:scale-125 group-hover:rotate-2 transition-all duration-700"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t ${category.color} opacity-0 group-hover:opacity-30 transition-opacity duration-500`}></div>
                  
                  {/* Shine Effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                </div>

                {/* Product Info */}
                <div className="p-6 relative">
                  <div className={`absolute top-0 left-0 w-full h-1 bg-gradient-to-r ${category.color} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500`}></div>
                  
                  <h3 className={`text-2xl font-bold mb-3 bg-gradient-to-r ${category.color} bg-clip-text text-transparent group-hover:scale-105 transition-transform duration-300`}>
                    {category.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed group-hover:text-gray-800 transition-colors duration-300">
                    {category.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-20 relative">
          <div className="absolute inset-0 bg-gradient-to-r from-red-600 via-orange-600 to-yellow-600 rounded-3xl blur-xl opacity-50 animate-pulse"></div>
          <div className="relative bg-gradient-to-r from-red-600 via-orange-600 to-yellow-600 rounded-3xl p-12 text-center text-white shadow-2xl overflow-hidden">
            {/* Animated Background Pattern */}
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 left-0 w-full h-full" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>
            </div>
            
            <div className="relative z-10">
              <div className="inline-block mb-6 animate-bounce">
                <i className="ri-question-line text-6xl"></i>
              </div>
              <h3 className="text-3xl lg:text-5xl font-bold mb-6 animate-pulse">
                {t('products_cta_title')}
              </h3>
              <p className="text-lg mb-10 text-white/95 max-w-2xl mx-auto font-medium">
                {t('products_cta_subtitle')}
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
                <button
                  onClick={() => {
                    const element = document.getElementById('contacto');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="bg-white text-red-600 px-10 py-5 rounded-full text-lg font-bold hover:bg-gray-100 transition-all shadow-2xl hover:scale-110 hover:shadow-white/50 whitespace-nowrap group"
                >
                  <i className="ri-mail-line mr-2 group-hover:animate-bounce"></i>
                  {t('products_cta_contact')}
                </button>
                <a
                  href="https://wa.me/13172790334"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-500 hover:bg-green-600 text-white px-10 py-5 rounded-full text-lg font-bold transition-all shadow-2xl hover:scale-110 hover:shadow-green-500/50 flex items-center gap-3 whitespace-nowrap group"
                >
                  <i className="ri-whatsapp-line text-2xl group-hover:rotate-12 transition-transform"></i>
                  {t('products_cta_whatsapp')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        .animate-slide-up {
          animation: slide-up 0.6s ease-out forwards;
          opacity: 0;
        }
        
        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }
      `}</style>
    </section>
  );
}
